import React, { useEffect, useLayoutEffect, useState } from 'react'

const PrivacyPolicy = () => {

    const [divElement, setDivElement] = useState<any | null>(null)

    useLayoutEffect(() => {
        let mytimer = setInterval(() => {
        let widget = document.getElementById("fc_widget")
        if (widget) {
          clearInterval(mytimer);
          setDivElement(widget);
        }
        }, 500)
      }, [divElement])
    
  
  useEffect(() => {
    if (divElement) {
        divElement.style.display = 'none'
      }
  }, [divElement])
  

  return (
    <div className='p-16'>
        <h1 className='text-center text-3xl'>Privacy Policy for Zerux</h1>

        <div className='mt-5' style={{width: '100%', opacity : 0.6, height: 2, backgroundColor: "#DEE6EA", borderRadius: 15}}>
        </div>

        <div className='p-10'>
                <div>
                    <h2 style={{fontWeight: 600}}>1. Introduction</h2>

                    <label className='mt-3'>Thank you for choosing Zerux, an accounting mobile application designed for businesses. This Privacy Policy is meant to help you understand what data we collect, why we collect it, and what we do with it. This is important; we hope you will take time to read it carefully.</label>
                    
                    <div className='mt-3'>
                    <label style={{display: 'block'}}>Company Information:</label>
                    <label style={{display: 'block'}}>Waku Software LLC</label>
                    <label style={{display: 'block'}}>605 NW 72ND AVE, Florida, US.</label>
                    </div>
                </div>

                <div className='mt-14'>
                    <h2 style={{fontWeight: 600}}>2. Information We Collect</h2>

                    <label className='mt-3'>When you use Zerux, we collect the following personal information for account management purposes:</label>
                    
                    <div className='mt-3'>
                    <label style={{display: 'block'}}>User ID</label>
                    <label style={{display: 'block'}}>Phone number</label>
                    <label style={{display: 'block'}}>Email address</label>
                    <label style={{display: 'block'}}>Postal address</label>
                    </div>
                </div>

                <div className='mt-14'>
                    <h2 style={{fontWeight: 600}}>3. How We Use Your Information</h2>

                    <label className='mt-3'>The personal information we collect is used for the sole purpose of account management. We do not share, sell, rent or trade your personal information with third parties.</label>
                </div>

                  <div className='mt-14'>
                    <h2 style={{fontWeight: 600}}>4. Email Communications</h2>

                    <label className='mt-3'>We may send emails to our users via AWS SES for the purpose of account management, notifications, updates or other application-related purposes. You will have the option to opt-out of these communications if you wish.</label>
                </div>

                  <div className='mt-14'>
                    <h2 style={{fontWeight: 600}}>5. No Tracking Tools</h2>

                    <label className='mt-3'>We do not use tracking tools or third-party analytics tools in our application.</label>
                </div>

                <div className='mt-14'>
                    <h2 style={{fontWeight: 600}}>6. Data Protection and Compliance</h2>

                    <label className='mt-3' style={{display: 'block'}}>A. GDPR (General Data Protection Regulation): For users within the European Union, we adhere to the principles of the GDPR. You have the right to access, correct, delete or transfer your personal data upon request.</label>
                    <label className='mt-3' style={{display: 'block'}}>B. CCPA (California Consumer Privacy Act) & CPRA (California Privacy Rights Act): For users within California, we comply with the CCPA and CPRA. You have the right to know what personal information is collected, access it, and request its deletion.</label>
                </div>

                <div className='mt-14'>
                    <h2 style={{fontWeight: 600}}>7. Data Retention</h2>

                    <label className='mt-3'>We retain your personal data for as long as necessary to fulfill the purposes for which we collected it, unless otherwise required by law.</label>
                </div>

                <div className='mt-14'>
                    <h2 style={{fontWeight: 600}}>8. Data Security</h2>

                    <label className='mt-3'>We are committed to ensuring that your information is secure. We have implemented suitable physical, electronic, and managerial procedures to safeguard the information we collect to prevent unauthorized access or disclosure.</label>
                </div>

                <div className='mt-14'>
                    <h2 style={{fontWeight: 600}}>9. Changes to This Privacy Policy</h2>

                    <label className='mt-3'>From time to time, we may update our Privacy Policy. Any changes will be posted on this page, and if the changes are significant, we will provide a more prominent notice, including, for certain services, email notification of changes.</label>
                </div>

                <div className='mt-14'>
                    <h2 style={{fontWeight: 600}}>10. How to Contact Us</h2>

                    <label className='mt-3'>If you have questions or concerns about this Privacy Policy, please contact us at:</label>

                    <div className='mt-3'>
                    <label style={{display: 'block'}}>Waku Software LLC</label>
                    <label style={{display: 'block'}}>605 NW 72ND AVE, Florida, US.</label>
                    <label style={{display: 'block', color: "#0264d6", fontWeight: 600}}>soporte@wakusoftware.com</label>
                    </div>

                </div>

        </div>
        
    </div>
  )
}

export default PrivacyPolicy